(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    class FitStandardBlock extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      const form = document.forms[this.getAttribute('observe-form')];
      const blockId = this.getAttribute('data-block-id');

      // Rather than patch this element in place, replace it wholesale with fresh markup
      // on every product update -- the same "always get a clean instance" behavior the
      // theme's own refreshed blocks (like the variant picker) already get, so an open
      // drawer never survives (and re-triggers) across variant/product changes.
      form?.addEventListener('product:rerender', (event) => {
        const fresh = event.detail.htmlFragment.querySelector(`fit-standard-block[data-block-id="${blockId}"]`);
        if (fresh) {
          this.replaceWith(fresh);
        } else {
          this.remove();
        }
      }, { signal: this._abortController.signal });
    }

    disconnectedCallback() {
      this._abortController.abort();
    }
  }

  if (!window.customElements.get('fit-standard-block')) {
    window.customElements.define('fit-standard-block', FitStandardBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class SizeChartDrawer extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      // Capture the drawer reference now, before it can ever be opened. An open
      // <x-drawer> teleports itself to document.body, so querying for it *inside
      // this element* later (once it may already be open) would find nothing.
      // Holding the reference directly keeps it valid no matter where it moves.
      this._drawers = Array.from(this.querySelectorAll('x-drawer'));
      const form = document.forms[this.getAttribute('observe-form')];

      form?.addEventListener('product:rerender', () => {
        this._drawers.forEach((drawer) => drawer.hide());
      }, { signal: this._abortController.signal });
    }

    disconnectedCallback() {
      this._abortController.abort();
    }
  }

  if (!window.customElements.get('size-chart-drawer')) {
    window.customElements.define('size-chart-drawer', SizeChartDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
